module.exports = __webpack_public_path__ + "456b5ddefb2e2878579854bcbf5010ff.svg";